import { Fragment } from "react";
import DoubleTextBlock from "../../components/DoubleTextBlock";
import GridItem from "../../components/general/GridItem";
import { mapModuleToHeroComponent } from "../text-on-content-module";

const DoubleTextOnContentModule = ({
	modules,
}: Queries.DoubleTextOnContentModuleFragment) => {
	return (
		<GridItem>
			<DoubleTextBlock>
				{modules &&
					modules.slice(0, 2).map((module) => {
						if (!module) return null;
						return (
							<Fragment key={module._uid}>
								{mapModuleToHeroComponent(module, "h2", true)}
							</Fragment>
						);
					})}
			</DoubleTextBlock>
		</GridItem>
	);
};

export default DoubleTextOnContentModule;
